export const colors = {
  white: '#FFFFFF',

  green: {
    '500': '#009CA3',
  },

  purple: {
    '100': '#B5ABD4',
    '500': '#2B0D61',
  },

  gray: {
    '100': '#FBFBFB',
    '300': '#E6E6E6',
    '600': '#989898',
    '700': '#404040',
    '800': '#0000001A',
    '900': '#00000029',
  },
};
